import React, { useState } from 'react';
import { Card, Col, ListGroup, Row } from 'react-bootstrap-5';
import { connect } from 'react-redux';
import { faCalendar, faPlus } from '@fortawesome/pro-solid-svg-icons';
import { Button } from 'components/ui/button';
import EmptyState from '../empty_state';
import NewTaskModal from '../call_list/tasks/new_task_modal';
import EditTaskModal from '../call_list/tasks/edit_task_modal';
import Task from '../call_list/tasks/task';
import { addActivity, removeActivity, updateActivity } from 'bundles/connect/components/store/actions/activities';
import { CONTACT_MODEL } from '../../constants';
import type { Activity, Contact } from 'bundles/connect/types';

type Props = {
  activities: Activity[];
  addActivity: (activity: Activity) => { type: string; payload: Activity };
  removeActivity: (id: number, type?: string) => ((dispatch: any) => Promise<void>);
  contact: Contact;
  updateActivity: (activity: Activity) => Promise<void>;
}

function TasksCard({ activities, contact, addActivity, removeActivity, updateActivity }: Props) {
  const [showNewTaskModal, setShowNewTaskModal] = useState(false);
  const [taskForEdit, setTaskForEdit] = useState<Activity | null>(null);
  const tasks = activities.filter(activity => activity.isTask && !activity.completedAt);

  return (
    <div>
      <Card>
        <Card.Header>
          <Row className="align-items-center">
            <Col xs="auto">
              <Button icon={faPlus} label="New" variant="secondary" onClick={() => setShowNewTaskModal(true)} />
            </Col>
          </Row>
        </Card.Header>
        {tasks.length === 0 && (
          <Card.Body>
            <EmptyState
              icon={faCalendar}
              text="There are no tasks in the queue."
            />
          </Card.Body>
        )}
        {tasks.length > 0 && (
          <ListGroup variant="flush">
            {tasks.map(task => (
              <Task
                key={task.id}
                task={task}
                onDelete={() => removeActivity(task.id, 'Task')}
                onEdit={setTaskForEdit}
                onUpdate={updateActivity}
              />
            ))}
          </ListGroup>
        )}
      </Card>
      <NewTaskModal
        initialConnectedRecords={
          [{ connectedRecordType: CONTACT_MODEL, connectedRecordId: contact.id, label: contact.name, link: '' }]
        }
        show={showNewTaskModal}
        onAdd={addActivity}
        onHide={() => setShowNewTaskModal(false)}
      />
      <EditTaskModal
        existingActivity={taskForEdit}
        onHide={() => setTaskForEdit(null)}
        onUpdate={updateActivity}
      />
    </div>
  );
}

const mapStateToProps = ({ activities }) => ({ activities });
export default connect(mapStateToProps, { addActivity, removeActivity, updateActivity })(TasksCard);
